<template>
  <div class="video-preview-control">
    <div v-if="video.number" class="preview-box">
      <div class="control-main">
        <div class="circle">
          <div class="arrow arrow-up" @mousedown="ptzControl(0)">
            <svg-icon name="roll-bottom"/>
          </div>
          <div class="arrow arrow-down" @mousedown="ptzControl(1)">
            <svg-icon name="roll-bottom"/>
          </div>
          <div class="arrow arrow-left" @mousedown="ptzControl(2)">
            <svg-icon name="roll-right"/>
          </div>
          <div class="arrow arrow-right" @mousedown="ptzControl(3)">
            <svg-icon name="roll-right"/>
          </div>
          <div class="camera camera-up" @mousedown="ptzControl(8)">
            <i class="el-icon-plus"></i>
          </div>
          <div class="camera camera-down" @mousedown="ptzControl(9)">
            <i class="el-icon-minus"></i>
          </div>
        </div>
      </div>
      <div class="slider">
        <span class="slow">{{$t('camera.slow')}}</span>
        <el-slider class="speed" v-model="speed" :min="1" :max="10"></el-slider>
        <span class="fast">{{$t('camera.fast')}}</span>
      </div>
    </div>
    <div v-else class="none">{{$t('camera.please_select_camera')}}</div>
  </div>
</template>
<script>
import cameraApi from "@/api/device/camera";
export default {
  props: {
    video: {
      type: Object,
      required: true,
      default: function () {
        return {
          number: '',
          camera_type: 1,
          channel: 1,
          access_token: ''
        }
      }
    },
  },
  data () {
    return {
      speed: 1,
      t1: null,
      direction: null//当前命令
    }
  },
  watch: {
    video: {
      handler(newVal, oldVal) {
        if(oldVal.number){
          if(newVal&&newVal.number){
            // this.ptzControl(12)
          }
        }
      }
    }
  },
  methods: {
    ptzControl (action) {
      const that = this
      cameraApi.videoControl({
        number: that.video.number,
        channel: that.video.channel,
        speed: that.speed,
        operation: action
      }).then((res) => {
        if (res.data.code === 1000) {
          if (action<12) {
            that.direction = action
            that.t1 = setTimeout(() => {
              that.ptzControl(12)
            }, 500)
          } else {
            clearInterval(that.t1)
          }
        } else {
          that.$message.error(res.data.message)
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
@color-primary:#0c82fe;
.video-preview-control {
  width: 280px;
  .preview-box {
    width:100%;
    .control-main{
      position: relative;
      width: 280px;
      height:280px;
      border:5px solid #000;
      border-radius: 50%;
      box-sizing: border-box;
      .circle {
        position: absolute;
        top: 15px;
        left: 15px;
        right: 15px;
        bottom: 15px;
        border-radius: 50%;
        background: #3a3a3c;
        .arrow,.camera {
          position: absolute;
          cursor: pointer;
          user-select: none;
          color:#fff;
          font-size: 32px;
          line-height: 0;
          &:hover{
            color: @color-primary;
          }
          &:active{
            color:#215278;
          }
          &.arrow-up{
            left:50%;
            top:15px;
            transform: translateX(-50%) rotate(180deg);
          }
          &.arrow-right{
            right:15px;
            top:50%;
            transform: translateY(-50%) rotate(0);
          }

          &.arrow-down{
            left:50%;
            bottom:15px;
            transform: translateX(-50%);
          }

          &.arrow-left{
            left:15px;
            top:50%;
            transform: translateY(-50%) rotate(180deg);
          }
        }
        .camera {
          background: #000;
          color: #fff;
          width: 100px;
          height: 48px;
          left: 50%;
          top:50%;
          font-size: 22px;
          transform: translateX(-50%);
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          &.camera-up {
            padding-top: 5px;
            margin-top:-50px;
            border-top-left-radius: 48px;
            border-top-right-radius: 48px;
          }
          &.camera-down {
            padding-bottom: 5px;
            margin-top:2px;
            border-bottom-left-radius: 48px;
            border-bottom-right-radius: 48px;
          }
        }
        
      }
    }

    .slider {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 20px;
      span {
        margin: 0 15px;
        color:#fff;
        font-size: 16px;
        &.slow{
          margin-left: 0;
        }
        &.fast{
          margin-right: 0;
        }
      }
      .speed {
        width: 100%;
        flex: 1;
      }
    }
  }
  .none{
    color:#6d7a8c;
    text-align: center;
  }
}




</style>
